import { SelectableFieldProps } from '../core-field/selectable-field-props'

export interface UI2PickerFieldProps extends SelectableFieldProps {
  /* Empty placeholder interface to allow functionality to be easily expanded in the future. */
}

/**
 * Default placeholder when the caller provides none: `Select <label>`, or a
 * bare 'Select' when the field is unlabelled.
 *
 * Phrased as an instruction rather than as the bare label on purpose — DW/MW
 * render the placeholder as the leading disabled `<option>`, where a string
 * identical to the label reads as a real, pickable choice.
 */
export function getDefaultPickerPlaceholder(label?: string): string {
  const trimmedLabel = label?.trim()
  return trimmedLabel ? `Select ${trimmedLabel}` : 'Select'
}
